import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/home/index",
  },
  {
    path: "/home/index",
    name: "HomeIndex",
    component: () => import("@/views/home/index.vue"),
    meta: {
      title: "首页",
    },
  },
  {
    meta: { title: "信息公开" },
    name: "Tax",
    path: "/tax",
    component: () => import("@/views/tax/index.vue"),
  },
  {
    meta: { title: "新闻动态" },
    name: "Xwdt",
    path: "/xwdt",
    component: () => import("@/views/xwdt/index.vue"),
  },
  {
    meta: { title: "通知公告" },
    name: "Tzgg",
    path: "/tzgg",
    component: () => import("@/views/tzgg/index.vue"),
  },
  {
    meta: { title: "专家智库" },
    name: "Zjzk",
    path: "/zjzk",
    component: () => import("@/views/zjzk/index.vue"),
  },
  {
    meta: { title: "AI聚合服务专区" },
    name: "Jhfwzqk",
    path: "/jhfwzq",
    component: () => import("@/views/jhfwzq/index.vue"),
  },
  // {
  //   meta: { title: "区域财源治理" },
  //   name: "Tax",
  //   path: "/tax-area",
  //   component: () => import("@/views/tax/index.vue"),
  // },
  // {
  //   meta: { title: "税收现代化" },
  //   name: "Tax",
  //   path: "/tax-modern",
  //   component: () => import("@/views/tax/index.vue"),
  // },
  // {
  //   meta: { title: "产业招商" },
  //   name: "Tax",
  //   path: "/tax-investment",
  //   component: () => import("@/views/tax/index.vue"),
  // },
  // {
  //   meta: { title: "数据资产入表" },
  //   name: "Tax",
  //   path: "/tax-data",
  //   component: () => import("@/views/tax/index.vue"),
  // },
  {
    meta: { title: "生态合作中心" },
    name: "Case",
    path: "/case",
    component: () => import("@/views/case/index.vue"),
  },
  {
    meta: { title: "数据产品中心" },
    name: "Tool",
    path: "/tool",
    component: () => import("@/views/toolbox/index.vue"),
  },
  {
    meta: { title: "数据服务中心" },
    name: "Course",
    path: "/course",
    component: () => import("@/views/course/index.vue"),
  },
  {
    meta: { title: "人才实训中心" },
    name: "Alliance",
    path: "/alliance",
    component: () => import("@/views/alliance/index.vue"),
  },
  {
    meta: { title: "园区介绍" },
    name: "Expert",
    path: "/expert",
    component: () => import("@/views/expert/index.vue"),
  },
  {
    meta: { title: "详情", keepAlive: false },
    path: "/detail/:path/:cateId/:contentId",
    component: () => import("@/views/article-detail/index.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_PATH,
  routes,
});
// 注册 beforeEach 钩子函数
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title}-泰山数据要素产业园`;
  } else {
    document.title = "泰山数据要素产业园";
  }
  next();
});
export default router;
